import { DEV, SBX } from "../../Constant";
import { IYearsList } from "../redux/Types";

/**
 * Returns the last 6 financial years with a one-year advance
 * 
 * @returns {IYearsList[]} The list of financial years
 */
export const getYearRange = (): IYearsList[] => {
  const yearRangeValues: IYearsList[] = [];
  const date = new Date();
  let yearCalculation: string;
  const localEnvs = [SBX, DEV];
  const isLocal = localEnvs.includes(process.env.APP_TARGET_ENV as string);
  let currentYear = isLocal ? 2019 : 2022;
  // Loop through 13 years
  for (let i = 0; i < 13; i++) {
    // To get the financial year 
    if ((date.getMonth() + 1) <= 3) {
      yearCalculation = (currentYear - 1) + "-" + currentYear;
    } else {
      yearCalculation = currentYear + "-" + (currentYear + 1);
    }
    // Add the financial year to the yearRangeValues list 
    yearRangeValues.push({
      text: `Financial year ${yearCalculation}`,
      value: `${yearCalculation}`,
    });
    // Increment the current year for the next iteration 
    currentYear += 1;
  }

  return yearRangeValues;
};
